import axios from 'axios'

export const fetchTenantAddress = async () => {
  const response = await axios.get('address')
  return response
}

export const fetchStateFromGSTINNumber = async (gstinNumber) => {
  const response = await axios.get(`address/fetch-state?gstin=${gstinNumber}`)
  return response
}

export const fetchCountries = async () => {
  const res = await axios.get('address/countries')
  return res
}

export const isValidAddress = async () => {
  const res = await axios.get('address/is-valid-address')
  return res
}
